/**
 * @generated SignedSource<<c12093c93229d0a282be04f4304708ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CleanupProjectPageUseIsReadOnlyQuery$variables = {
  locator: string;
};
export type CleanupProjectPageUseIsReadOnlyQuery$data = {
  readonly projectsRest: {
    readonly " $fragmentSpreads": FragmentRefs<"CleanupProjectPageUseIsReadOnlyFragment">;
  } | null | undefined;
};
export type CleanupProjectPageUseIsReadOnlyQuery = {
  response: CleanupProjectPageUseIsReadOnlyQuery$data;
  variables: CleanupProjectPageUseIsReadOnlyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CleanupProjectPageUseIsReadOnlyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Projects",
        "kind": "LinkedField",
        "name": "projectsRest",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CleanupProjectPageUseIsReadOnlyFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CleanupProjectPageUseIsReadOnlyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Projects",
        "kind": "LinkedField",
        "name": "projectsRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "project",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "df84b9ceacc8c77af7dc9a86f52289e3",
    "id": null,
    "metadata": {},
    "name": "CleanupProjectPageUseIsReadOnlyQuery",
    "operationKind": "query",
    "text": "query CleanupProjectPageUseIsReadOnlyQuery(\n  $locator: String!\n) {\n  projectsRest(locator: $locator) {\n    ...CleanupProjectPageUseIsReadOnlyFragment\n  }\n}\n\nfragment CleanupProjectPageUseIsReadOnlyFragment on Projects {\n  project {\n    rawId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "12d5bccfdc7a38f88b6cfc703b8e4ea0";

export default node;
